// src/pages/MyPage.js
import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import FeedbackForm from "../components/FeedbackForm";
import {useAuth} from "../contexts/authContext";

const MyPage = () => {
  const navigate = useNavigate();
  const [showFeedback, setShowFeedback] = useState(false);
  const [userNickname, setUserNickname] = useState('');
  const { isLoggedIn, setIsLoggedIn, userEmail, setUserEmail } = useAuth();

  useEffect(() => {
    const nickname = localStorage.getItem("nickname");
    if (nickname) setUserNickname(nickname);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("nickname");
    localStorage.removeItem("usage_count");
    localStorage.removeItem("daily_limit");
    setIsLoggedIn(false);
    setUserEmail("");
    alert("로그아웃 되었습니다.");
    navigate("/login");
  };

  return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-white">
        <header
            className="w-full flex flex-col md:flex-row justify-between items-center px-4 py-4 border-b bg-white dark:bg-gray-800">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h1 className="text-xl font-bold text-blue-600 dark:text-blue-300">J_Universe</h1>

            <nav className="mt-2 text-sm">
              <Link to="/" className="hover:text-blue-400">J_Universe</Link>
              <span className="mx-2">|</span>
            </nav>
          </div>

          <div className="flex flex-col items-end gap-2 mt-4 md:mt-0">
            {isLoggedIn && (
                <div className="text-sm font-semibold text-green-300 text-center md:text-right w-full">
                  어서오세요, <span className="text-yellow-400">{userNickname}</span> 님
                </div>
            )}
            <div className="flex gap-2">
              {isLoggedIn ? (
                  <button
                      onClick={handleLogout}
                      className="px-4 py-2 text-sm font-semibold bg-red-500 text-white rounded-full">
                    Sign out
                  </button>
              ) : (
                  <Link
                      to="/login"
                      className="px-4 py-2 text-sm font-semibold bg-blue-500 text-white rounded-full">
                    Sign in
                  </Link>
              )}
               {!isLoggedIn && (
                <Link
                  to="/signup"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  Sign up
                </Link>
              )}
              {isLoggedIn && (
                <Link
                  to="/mypage"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  MyPage
                </Link>
              )}
            </div>
          </div>
        </header>
        <div className="max-w-md mx-auto mt-10 p-6 bg-gray-300 rounded-xl shadow">
          <h2 className="text-2xl text-gray-700 font-bold text-center mb-4">마이페이지</h2>
          <p className="text-center text-gray-700 mb-6">환영합니다, <strong>{userNickname}</strong>님!</p>

          <div className="space-y-4">
                       <button
              onClick={() => navigate("/")}
              className="w-full py-2 bg-blue-700 text-white rounded-lg hover:bg-blue-600"
            >
              메인페이지로
            </button>
            <button
              onClick={() => navigate("/brain-age-history")}
              className="w-full py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              🧠 뇌 나이 히스토리 보기
            </button>

            <button
              onClick={() => navigate("/history")}
              className="w-full py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              🗣️ 말해조 히스토리
            </button>

            <button
              onClick={() => navigate("/usage")}
              className="w-full py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700"
            >
              📊 잔여 횟수 보기
            </button>

            {/* <button*/}
            {/*  className="w-full py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600"*/}
            {/*  onClick={() => navigate("/purchase")}*/}
            {/*>*/}
            {/*  💰 횟수 충전하기*/}
            {/*</button>*/}

            <button
              onClick={() => navigate("/inquiry")}
              className="w-full py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600"
            >
              📩 1:1 문의
            </button>

            <button
              onClick={() => setShowFeedback(true)}
              className="w-full py-2 bg-blue-700 text-white rounded-lg hover:bg-blue-600"
            >
              💬 서비스 개선 건의 Feedback 보내기
            </button>
            {showFeedback && <FeedbackForm onClose={() => setShowFeedback(false)} />}


            <button
              onClick={() => navigate("/change-password")}
              className="w-full py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600"
            >
              🔑 비밀번호 변경
            </button>

            <button
              onClick={() => navigate("/delete-account")}
              className="w-full py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
            >
              ❌ 회원 탈퇴
            </button>

            <button
              onClick={handleLogout}
              className="w-full py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500"
            >
              로그아웃
            </button>
          </div>
        </div>
    </div>
  );
};

export default MyPage;
